module.exports = __webpack_public_path__ + "static/media/resetfresh-icon.74af3d9b.svg";